export const featureFlags = {
  showExplainerVideo: false,
  /** Create Room modal intro-video upload — re-enable when the feature ships. */
  showCreateRoomIntroVideo: false,
  /** In-app Notifications settings — unused; keep code, hide UI until needed. */
  showNotificationsSettings: false,
} as const;